__turbopack_context__.v({
  "iframe": "BoardSectionItemEmbed-module-scss-module__7kPv2G__iframe",
  "initialized": "BoardSectionItemEmbed-module-scss-module__7kPv2G__initialized",
  "large": "BoardSectionItemEmbed-module-scss-module__7kPv2G__large",
  "wrapper": "BoardSectionItemEmbed-module-scss-module__7kPv2G__wrapper",
});
